import z from 'zod';
var validator = z.object({
    _type: z.literal('file')
}).passthrough().refine(function(value) {
    return true;
});
export default {
    validator: validator
};

//# sourceMappingURL=sanityFile.js.map